<template>
  <div class="platformNew home">
    <el-row :gutter="10">
      <el-col :span="16">
        <div class="platBlock statistics">
          <div class="statisticsItem" v-for="(item,index) in messageAlertList" :key="index" @click="toView(item)">
            <span>{{ item.value || 0 }}</span>
            <span>{{ item.title }}</span>
          </div>
        </div>
        <!--工作进程-->
        <div class="platBox process" v-loading="workCourseLoading">
          <div class="platBoxTitle">
            <span>工作进程</span>
          </div>
          <div class="platBoxContent">
            <el-row :gutter="20">
              <el-col :span="19" :offset="5">
                <div class="steps">
                  <div class="step">影像扫描</div>
                  <div class="step">单据处理</div>
                  <div class="step">制单</div>
                  <div class="step">复核</div>
                  <div class="step">报税</div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-for="(item, index) in companyListFilter" :key="index">
              <el-col :span="5" class="companyName">
                <el-popover
                  placement="right"
                  :title="item.customName"
                  width="800"
                  trigger="click"
                  @show="getWorkCountStatus(item)"
                  @after-leave="afterLeave">
                  <bsp-grid
                    style="height: 250px"
                    ref="xGrid"
                    :demoLoading.sync="demoLoading"
                    :tableColumns.sync="tableColumns"
                    :tableDatas.sync="tableDatas"
                  >
                    <template v-slot:detailData="{row}">
                      <span class="statusText" v-if="row.successCount != undefined">
                        <i class="success">{{ row.successCount }}</i> /
                      </span>
                      <span class="statusText" v-if="row.failCount != undefined">
                        <i class="fail">{{ row.failCount }}</i> /
                      </span>
                      <span class="statusText">{{ row.total }}</span>
                    </template>
                  </bsp-grid>
                  <span slot="reference" style="cursor: pointer">{{item.customName}}</span>
                </el-popover>
              </el-col>
              <el-col :span="19">
                <div class="steps stepsLine">
                  <div :class="'step' + (item['00'+ n] == -1 ? '' : ' step' + item['00'+ n].value)" v-for="n in 5" :key="n" :title="item['00' + n].remark"></div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="processBtn">
            <div class="prev" @click="handlePrev" :class="{disabled : page == 1}">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-zuojiantou"></use>
              </svg>
            </div>
            <div class="next" @click="handleNext" :class="{disabled : page == count || count == 0}">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-youjiantou"></use>
              </svg>
            </div>
          </div>
        </div>
        <!--日历-->
        <div class="platBox calendar">
          <Calendar></Calendar>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="platBox agency">
          <div class="platBoxTitle">
            <span>本月待办</span>
            <!--<span class="platBoxDate">-->
              <!--<span class="pDate">16</span>/5月-->
            <!--</span>-->
          </div>
          <div class="platBoxContent">
            <div class="agencyLists">
              <div class="agencyHead blue">
                <span>进项税认证</span>
                <span v-if="agencyList.jxsrz.length > 3" @click="agencyOpen(0)">
                  <svg class="icon" aria-hidden="true" v-if="agencyOpenIndex == 0">
                    <use xlink:href="#icon-xiala"></use>
                  </svg>
                  <svg class="icon" aria-hidden="true" v-else>
                    <use xlink:href="#icon-zuo"></use>
                  </svg>
                </span>
              </div>
              <div class="agencyList" v-if="agencyOpenIndex != 0">
                <template v-for="(item,index) in agencyList.jxsrz">
                  <p v-if="index < 3">
                    {{item.customname}}
                  </p>
                </template>
              </div>
              <div class="agencyList" v-else>
                <p v-for="(item, index) in agencyList.jxsrz" :key="index">
                  {{item.customname}}
                </p>
              </div>
            </div>
            <div class="agencyLists">
              <div class="agencyHead red">
                <span>税金计提</span>
                <span v-if="agencyList.sjjt.length > 3" @click="agencyOpen(1)">
                  <svg class="icon" aria-hidden="true" v-if="agencyOpenIndex == 1">
                    <use xlink:href="#icon-xiala"></use>
                  </svg>
                  <svg class="icon" aria-hidden="true" v-else>
                    <use xlink:href="#icon-zuo"></use>
                  </svg>
                </span>
              </div>
              <div class="agencyList" v-if="agencyOpenIndex != 1">
                <template v-for="(item,index) in agencyList.sjjt">
                  <p v-if="index < 3">
                    {{item.customname}}
                  </p>
                </template>
              </div>
              <div class="agencyList" v-else>
                <p v-for="(item, index) in agencyList.sjjt" :key="index">
                  {{item.customname}}
                </p>
              </div>
            </div>
            <div class="agencyLists">
              <div class="agencyHead green">
                <span>税金缴纳</span>
                <span v-if="agencyList.sjjn.length > 3" @click="agencyOpen(2)">
                  <svg class="icon" aria-hidden="true" v-if="agencyOpenIndex == 2">
                    <use xlink:href="#icon-xiala"></use>
                  </svg>
                  <svg class="icon" aria-hidden="true" v-else>
                    <use xlink:href="#icon-zuo"></use>
                  </svg>
                </span>
              </div>
              <div class="agencyList" v-if="agencyOpenIndex != 2">
                <template v-for="(item,index) in agencyList.sjjn">
                  <p v-if="index < 3">
                    {{item.customname}}
                  </p>
                </template>
              </div>
              <div class="agencyList" v-else>
                <p v-for="(item, index) in agencyList.sjjn" :key="index">
                  {{item.customname}}
                </p>
              </div>
            </div>
            <div class="agencyLists">
              <div class="agencyHead yellow">
                <span>资产折旧/摊销</span>
                <span v-if="agencyList.zczjtx.length > 3" @click="agencyOpen(3)">
                  <svg class="icon" aria-hidden="true" v-if="agencyOpenIndex == 3">
                    <use xlink:href="#icon-xiala"></use>
                  </svg>
                  <svg class="icon" aria-hidden="true" v-else>
                    <use xlink:href="#icon-zuo"></use>
                  </svg>
                </span>
              </div>
              <div class="agencyList" v-if="agencyOpenIndex != 3">
                <template v-for="(item,index) in agencyList.zczjtx">
                  <p v-if="index < 3">
                    {{item.customname}}
                  </p>
                </template>
              </div>
              <div class="agencyList" v-else>
                <p v-for="(item, index) in agencyList.zczjtx" :key="index">
                  {{item.customname}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--消息-->
        <div class="platBox msgs">
          <div class="platBoxTitle">
            <span>消息</span>
            <!--<span class="platBoxDate">-->
              <!--<router-link to="/">查看更多</router-link>-->
            <!--</span>-->
          </div>
          <div class="platBoxContent">
              <p class="msgLine ellipsis" v-for="item in msgsList" :key="item.id">
                {{item.msg}}
              </p>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Calendar from "./calendarWCS";
  import bspGrid from "@/components/bsp/bsp-grid/grid";
  import { workCourse, doRemind, workCountStatus, messageAlert } from '@/api/home/platformWCS';
  import { formatNum } from "../../util/util";
  import { mapGetters } from 'vuex';
  export default {
    name: "platformWCS",
    components:{Calendar,bspGrid},
    data(){
      return{
        companyList:[],       // 工作进程
        agencyOpenIndex:null, //本月代办展开
        agencyList:{          //本月代办
          jxsrz:[],
          sjjt:[],
          sjjn:[],
          zczjtx:[],
        },
        msgsList:[
        ],
        calendarMonth:"",     //日历月份
        year: '',
        month: '',
        page: 1,
        limit: 5,
        messageAlertData: {},
        demoLoading: false,
        workCourseLoading: false,
        tableColumns: [],
        tableDatas: []
      }
    },
    mounted() {
      this.getColumns();
      this.setDate();
      this.getWorkCourse();
      this.getDoRemind();
      this.getMessageAlert();
    },
    methods:{
      getColumns() {
        let column = [
          {
            field: "sectorName",
            title: "环节",
          },
          {
            field: "statusText",
            title: "状态",
            // params: { slot: 'statusText' }
          },
          {
            field: "details",
            title: "详情",
            params: { slot: 'detailData' }
          }
        ];
        this.$set(this,"tableColumns",column);
      },
      // 设置日期
      setDate() {
        const yearMonth = new Date(this.userInfo.month);
        this.year = yearMonth.getFullYear();
        this.month = formatNum(yearMonth.getMonth() + 1);
      },
      agencyOpen(index){
        if(index == this.agencyOpenIndex){
          this.$set(this,"agencyOpenIndex",null);
        }else{
          this.$set(this,"agencyOpenIndex",index);
        }
      },
      /**
       * 获取本月代办
       * one-进项税认证
       * two-税金计提
       * three- 税金缴纳
       * four-资产折旧/摊销
       */
      getDoRemind() {
        let params = {
          year: this.year,
          month: this.month
        }
        doRemind(params.year, params.month)
          .then(response => {
            const result = response.data.data;
            this.agencyList.jxsrz = result.one || [];
            this.agencyList.sjjt = result.two || [];
            this.agencyList.sjjn = result.three || [];
            this.agencyList.zczjtx = result.four || [];
          })
          .catch(error => {

          })
      },
      // 工作进程
      getWorkCourse() {
        this.workCourseLoading = true;
        let params = {
          year: this.year,
          month: this.month,
          perId: this.userInfo.perId
        }
        workCourse(params.year, params.month, params.perId)
          .then(response => {
            this.workCourseLoading = false;
            const result = response.data.data;
            this.companyList = result;
          })
          .catch(error => {
            this.workCourseLoading = false;
          })
      },
      // 异常提醒
      getMessageAlert() {
        let params = {
          year: this.year,
          month: this.month
        }
        messageAlert(params.year, params.month)
          .then(response => {
            const result = response.data.data;
            this.messageAlertData = result;
          })
          .catch(error => {

          })
      },
      // 跳转到异常对应页面
      toView(messageAlert) {
        const { path, query } = messageAlert;
        this.$router.push({
          path,
          query
        });
      },
      handlePrev() {
        if (this.page > 1) {
          this.workCourseLoading = true;
          this.page --;
          setTimeout(() => {
            this.workCourseLoading = false;
          },300);
        }
      },
      handleNext() {
        if (this.page < this.count) {
          this.workCourseLoading = true;
          this.page ++;
          setTimeout(() => {
            this.workCourseLoading = false;
          },300);
        }
      },
      // 获取客户节点详情
      getWorkCountStatus(customer) {
        this.demoLoading = true;
        let params = {
          year: this.year,
          month: this.month,
          cusId: customer.cusId
        }
        workCountStatus(params.year, params.month, params.cusId)
          .then(response => {
            this.demoLoading = false;
            const result = response.data.data;
            let tableDatas = [
              {
                sectorName: '影像扫描',
                statusText: customer['001'] != -1 ? customer['001'].remark : '',
                successCount: result.filesuccesscount,
                failCount: result.filefailcount,
                total: result.filesuccesscount + result.filefailcount + result.fileprocount
              },
              {
                sectorName: '单据处理',
                statusText: customer['002'] != -1 ? customer['002'].remark : '',
                successCount: result.batchsuccesscount,
                failCount: result.batchfailcount,
                total: result.batchsuccesscount + result.batchfailcount + result.batchprocount
              },
              {
                sectorName: '制单',
                statusText: customer['003'] != -1 ? customer['003'].remark : '',
                successCount: result.vouzdcount,
                total: result.voucount
              },
              {
                sectorName: '复核',
                statusText: customer['004'] != -1 ? customer['003'].remark : '',
                successCount: result.voufhcount,
                total: result.voucount
              }
            ];
            this.tableDatas = tableDatas;
          })
          .catch(error => {
            this.demoLoading = false;
          })
      },
      // 弹框隐藏，清空表格数据
      afterLeave() {
        this.tableDatas = [];
      }
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ]),
      count() {
        return Math.ceil(this.companyList.length / this.limit);
      },
      companyListFilter() {
        return this.companyList.slice((this.page -1) * this.limit, this.page * this.limit);
      },
      messageAlertList() {
        const messageAlertData = this.messageAlertData;
        let items = [];
        if (messageAlertData.value) {
          const messageAlertDataValue = messageAlertData.value[0];
          if (messageAlertData.key == 1) {
            items.push({
              title: '单据影像失败',
              value: messageAlertDataValue.COUNT,
              path: '/bill/billLists'
            });
          }
          if (messageAlertData.key == 2) {
            items.push({
              title: '未核对开票记录',
              value: messageAlertDataValue['invoiceCount'.toUpperCase()],
              path: '/bill/billCheck',
              query: {
                tab: 'InvoiceRecord'
              }
            });
            items.push({
              title: '未核对对账单',
              value: messageAlertDataValue['cashAccountCount'.toUpperCase()],
              path: '/bill/billCheck',
              query: {
                tab: 'BankReconciliation'
              }
            });
            items.push({
              title: '异常单据',
              value: messageAlertDataValue['fileFailCount'.toUpperCase()],
              path: '/bill/billManagement/billManagementList'
            });
          }
          if (messageAlertData.key == 3) {
            items.push({
              title: '未核对开票记录',
              value: messageAlertDataValue['invoiceRecordCount '.toUpperCase()],
              path: '/bill/billCheck',
              query: {
                tab: 'InvoiceRecord'
              }
            });
            items.push({
              title: '未核对对账单',
              value: messageAlertDataValue['bankCashCount'.toUpperCase()],
              path: '/bill/billCheck',
              query: {
                tab: 'BankReconciliation'
              }
            });
            // items.push({
            //   title: '未核对报销单',
            //   value: messageAlertDataValue['billCount'.toUpperCase()]
            // });
            items.push({
              title: '审单',
              value: messageAlertDataValue['costInfoCount'.toUpperCase()],
              path: '/cost/costServerCheckAction_serverCheckBill.action?'

            });
            items.push({
              title: '待复核凭证',
              value: messageAlertDataValue['voucherCount '.toUpperCase()],
              path: '/voucher/toVoucherUFTab.action'
            });
          }
          if (messageAlertData.key == 4) {
            items.push({
              title: '待付款',
              value: messageAlertDataValue['tellerCount'.toUpperCase()],
              path: '/cashier_toCashTellerSet.action'
            });
            items.push({
              title: '开票',
              value: messageAlertDataValue['fapiaoCount'.toUpperCase()],
              path: '/fapiao/fapiaoApplication_toFapiaoViewTabs.action'
            });
            items.push({
              title: '认证进项税',
              value: messageAlertDataValue['verifyBatchCount'.toUpperCase()],
              path: '/accounts/inputTax/inputTaxList'
            });
          }
        }
        return items;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .platformNew{
    margin-top: 10px;
  }
  .platBlock{
    background: #FFFFFF;
    box-shadow: 0px 1px 4px 0px rgba(140, 140, 140, 0.26);
    border-radius: 4px;
  }
  .statistics{
    display: flex;
    align-items: center;
    height: 120px;
    padding: 0 10px;
  }
  .statisticsItem{
    cursor: pointer;
    display: flex;
    flex-direction: column;
    position: relative;
    text-align: center;
    width: 20%;
    &:hover {
      box-shadow: 0px 2px 8px #ccc;
      &.statisticsItem::before {
        background-color: transparent;
      }
    }
  }
  .statisticsItem:first-child::before{
    display: none;
  }
  .statisticsItem::before{
    content:"";
    position: absolute;
    left:0;
    top:50%;
    margin-top:-24px;
    width: 2px;
    height: 48px;
    background: #EAEAEA;
    border-radius: 1px;
  }
  .statisticsItem span{
    font-size: 30px;
    line-height: 42px;
    margin-bottom: 7px;
    color:#DE4A4A;
  }
  .statisticsItem span+span{
    font-size: 14px;
    line-height: 20px;
    color:#999999;
  }
  .platBox{
    background: #FFFFFF;
    box-shadow: 0px 1px 4px 0px rgba(140, 140, 140, 0.26);
    border-radius: 4px;
    .platBoxTitle{
      line-height: 40px;
      padding:2px 20px 0;
      font-size: 20px;
      color:#666666;
      justify-content: space-between;
      display: flex;
      .platBoxDate{
        color:#666666;
        font-size: 20px;
        .pDate{
          font-size: 40px;
          font-weight: bold;
        }
      }
    }
    .platBoxContent{
      padding:0 20px;
    }
  }
  .process{
    height: 350px;
    margin-top: 10px;
    position: relative;
    .companyName{
      line-height: 44px;
      color:#333333;
      text-align: right;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    }
    .steps{
      display: flex;
      height: 44px;
      align-items: center;
      .step{
        flex:1;
        font-size: 14px;
        color:#333333;
        text-align: center;
        font-weight: bold;
      }
      &.stepsLine{
        .step{
          margin-left: 1px;
          height: 10px;
          background-color: #E9E9E9;
          &:first-child {
            border-radius: 6px 0 0 6px;
          }
          &:last-child {
            border-radius: 0 6px 6px 0;
          }
        }
        .step1{
          background-color: #E9E9E9;
        }
        .step2{
          background-color: #FCFF40; // 黄色
        }
        .step3{
          background-color: #F9A94B; // 黄色（警告）
        }
        .step4{
          background-color: #D7350C; // 红色
        }
        .step5{
          background-color: #44E335; // 绿色（亮）
        }
        .step6{
          background-color: #65CFA1; // 绿色
        }
        .step7{
          background-color: #f56c6c; // 红色（危险）
        }
      }
    }
    .processBtn{
      position: absolute;
      bottom:15px;
      left:0;
      right:0;
      display: flex;
      padding:0 250px;
      justify-content: space-evenly;
      div{
        display: flex;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #C73122;
        cursor: pointer;
        color:#ffffff;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        &.disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
      }
    }
    .platBoxContent{
      margin-top: -20px;
    }
  }
  .agency{
    padding-top: 10px;
    height: 690px;
    .agencyHead{
      position: relative;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color:#333333;
      font-weight: bold;
      padding-left:16px;
      line-height: 50px;
      .icon{
        color:#666666;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .agencyHead::before{
      content: "";
      width: 6px;
      height: 14px;
      position: absolute;
      border-radius: 2px;
      top:18px;
      left:0;
    }
    .blue.agencyHead::before{
      background: #5F91D4;
    }
    .red.agencyHead::before{
      background: #D45FB2;
    }
    .green.agencyHead::before{
      background: #5ABA69;
    }
    .yellow.agencyHead::before{
      background: #CB997D;
    }
    .agencyLists{
      margin-bottom: 10px;
    }
    .agencyList{
      padding-left: 20px;
      min-height: 94px;
      p{
        background: #F5F5F5;
        border-radius: 8px;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        color:#333333;
        padding-left: 12px;
        margin: 5px 0;
      }
    }
    .platBoxContent{
      height: 636px;
      overflow-y: auto;
    }
  }
  .msgs{
    margin-top: 10px;
    .platBoxTitle {
      .platBoxDate {
        font-size: 12px;
        color: #999999;
      }
    }
    .msgLine{
        font-size: 14px;
        line-height: 32px;
        border-top:1px dashed #B0B0B0;
        color:#000000;
        font-weight: 400;
    }
    .msgLine:first-child{
      border:none;
    }
  }
  .calendar{
    margin-top: 10px;
    padding: 15px;
  }
  .success{
    color: #65CFA1;
  }
  .fail{
    color: #f56c6c;
  }
  .statusText {
    font-size: 16px;
  }
</style>
